var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { casesActivityMock } from '../../data/__mocks__/activitiesMock';
import { ActivityRepository } from '../../infrastructure/repositories/activity.repository.impl';
export class ActivityService {
    constructor() {
        this.repository = new ActivityRepository();
    }
    //TODO: esto hay que quitarlo cuando el php haga los calculos sobre los ids y no sobre los literales. Habrá que usar getActivitiesWithTranslationAsync().
    // En el json de preguntas habra que sustituir "method": "getActivitiesMock" por "method": "getActivitiesWithTranslationAsync"
    getActivitiesMock() {
        return casesActivityMock;
    }
    getActivitiesWithTranslationAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.repository.getActivitiesWithTranslationAsync();
            }
            catch (error) {
                return [];
            }
        });
    }
}
